package com.yogaaicoach.pages.trainingprogram

import kotlinx.serialization.Serializable

// Mirrors composeApp's Duration enum (pages/trainingprogram/add/WeekdayStateModel.kt) — strips
// the StringResource title/description fields, keeps the plain `minutes` field the serializer
// and display logic both need.
@Serializable(with = DurationSerializer::class)
enum class Duration(val minutes: Int) {
    Minutes15(15),
    Minutes30(30),
    Minutes45(45),
    Minutes60(60);

    companion object {
        fun fromMinutes(minutes: Int): Duration = entries.find { it.minutes == minutes } ?: Minutes15
    }
}
